import React from 'react';

import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import { LISTING_HEAP_IDS } from '../../../../constants';
import styles from './StaticMap.module.scss';

export const StaticMap: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    return (
        <div className={styles.staticMap}>
            <Button
                variant="secondary"
                onClick={onClick}
                sizeVariant="large"
                aria-label="Show interactive map"
                data-heap-id={LISTING_HEAP_IDS.SHOW_MAP}
            >
                {gettext('Show map')}
            </Button>
        </div>
    );
};
